<template>
  <div class="w-100 h-100">
    <div class="col-12 d-flex flex-row justify-content-between align-items-start pt-2 h-100">
      <div class="card col-3s h-100 shadow-lg rounded-lg p-3">
        <div class="card-body pb-0">
          <div class="media flex-column justify-content-center align-items-center border-bottom">
            <img
              ref="imageAvatar"
              src="@assets/images/users/avatar-7.jpg"
              class="avatar-xxl rounded-circle"
              alt="avatar"
            />
            <div class="text-center w-100">
              <h5 class="mt-3 mb-0">{{ model.full_name }}</h5>
              <h6 class="font-weight-normal mt-1 mb-2 text-muted">
                {{ model.present_work }}
              </h6>
            </div>
            <div class="mt-1 h6">
              <a
                v-if="model.facebook"
                :href="model.facebook"
                title="facebook"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-facebook text-primary"></i>
              </a>
              <a
                v-if="model.twitter"
                :href="model.twitter"
                title="twitter"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-twitter text-info"></i>
              </a>
              <a
                v-if="model.dribbble"
                :href="model.dribbble"
                title="dribbble"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-dribbble text-danger"></i>
              </a>
              <a
                v-if="model.behance"
                :href="model.behance"
                title="behance"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-behance"></i>
              </a>
            </div>
          </div>
          <div class="text-left mb-3 border-bottom">
            <ul class="list-unstyled events mb-0 font-1 text-muted">
              <li class="my-2">
                <i class="mr-2 uil-user"></i>
                {{ model.gender | capitalize }}
              </li>
              <li class="my-2">
                <i class="mr-2 uil-gift"></i>
                {{ model.date_of_birth | date }}
              </li>
              <li class="my-2">
                <i class="mr-2 uil-location-point"></i>
                {{ model.city || "" }} {{ model.country || "-" }}
              </li>
              <li class="my-2">
                <i class="mr-2 uil-phone"></i>
                {{ model.contact_no || "-" }}
              </li>
              <li class="my-2">
                <i class="mr-2 uil-envelope"></i>
                {{ model.email || "N/A" }}
              </li>
              <li class="my-2">
                <i class="mr-2 uil-globe"></i>
                {{ model.website || "-" }}
              </li>
            </ul>
          </div>
        </div>
        <div class="w-100 pb-2 mb-2">
          <button
              class="btn btn-primary w-100"
              v-if="!model.has_consent"
              @click="resend"
            >
              <i class="uil-envelope-alt"></i> Resend Consent
            </button>
        </div>
      </div>
      <div class="w col-8s h-100">
        <b-tabs class="">
          <b-tab class="custom-bg-color" :title="$t('user.form.suitable_jobs')" active>
            <SuitableJobs :parameters="{ applicationID: applicationID }" />
          </b-tab>
          <b-tab :title="$t('user.form.applications')">
            <Applications ref="applications" :parameters="{ applicationData: model.applications }" />
          </b-tab>
          <b-tab :title="$t('user.form.interviews')">
            <div 
              class="text-center"
            >{{$t('user.form.empty_interviews')}}</div>
          </b-tab>
          <b-tab :title="$t('user.form.activities')">
            <div class="row col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title pb-2 border-bottom">{{$t('candidate.form.activities')}}</h5>
                  <VuePerfectScrollbar style="max-height: 500px">
                    <div 
                      class="text-center"
                      v-if="!model.activities.length"
                      >{{$t('candidate.form.empty_activities')}}.</div>
  
                      <div class="custom-timeline pl-4" 
                        v-for="item in model.activities"
                        :key="item._id"
                      >
                        <ul class="list-unstyled events">
                          <li class="event-list" >
                            <div v-if="item.type == 'application'">
                              <div class="event-date text-muted pt-2">
                                <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}} | {{ item.recruiter_id ? item.recruiter_id.full_name : '' }} </span>
                              </div>
                              <div class="media">
                                <div class="media-body">
                                  
                                  <div class="card">
                                    <div class="card-body mt-3">
                                      <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                      <p class="text-muted">
                                        {{ item.description }}
                                      </p>
                                      <div v-if="item.job_id">Position: {{ item.job_id.title }}</div>
                                      <div v-if="item.job_id">Company: {{ item.job_id.company_id.name }}</div>
                                    </div>
                                  </div>
  
                                </div>
                              </div>
                            </div>
                            <div v-else-if="item.type == 'schedule' || item.type == 'reschedule'">
                              <div class="event-date text-muted pt-2">
                                <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                              </div>
                              <div class="media">
                                <div class="media-body">
                                  
                                  <div class="card">
                                    <div class="card-body mt-3">
                                      <h5 class="mt-0"><i class="uil uil-calendar-alt"></i> {{ item.title }}</h5>
                                      <p class="text-muted">
                                        {{ item.description }}
                                      </p>
                                      <div v-if="item.job_id">Position: {{ item.job_id.title }}</div>
                                      <div v-if="item.job_id">Company: {{ item.job_id.company_id.name }}</div>
                                    </div>
                                  </div>
  
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div class="event-date text-muted pt-2">
                                <span class="font-size-15">{{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('HH:mm A')}}</span>
                              </div>
                              <div class="media">
                                <div class="media-body">
                                  
                                  <div class="card">
                                    <div class="card-body mt-3">
                                      <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                      <p class="text-muted">
                                        {{ item.description }}
                                      </p>
                                    </div>
                                  </div>
  
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
  
                  </VuePerfectScrollbar>
                  
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab :title="$t('user.form.files')">
            <div class="row">
              <div class="text-left col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title border-bottom">Resume</h5>
                    <div 
                      v-for="(item, idx) in attachmentDatas"
                      :key="item._id"
                    >
                      <div class="section">
                        <div class="'collapsible">
                          <div class="p-1 px-2">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <img 
                                  src="@assets/images/projects/project-1.jpg"
                                  class="avatar-sm rounded"
                                  alt="file-image"
                                >
                              </div>
                              <div class="col pl-0" style="white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;">
                                  <a href="javascript:void(0);" class="text-muted font-weight-bold">
                                    {{ item.fileName }}
                                  </a>
                                  <p class="mb-0">{{ item.size.$numberDecimal | bytes }}</p>
                              </div>
                              <div class="col-auto">
                                <a
                                  @click="onDownloadAttachment(item._id, idx)"
                                  data-toggle="tooltip" 
                                  data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                  data-original-title="Download">
                                    <i class="uil uil-cloud-download font-size-14"></i>
                                </a>
                                <a
                                  @click="onDeleteAttachment(item._id, idx)"
                                  data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                    <i class="uil uil-multiply font-size-14"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div 
                      v-for="(item, idx) in attachmentPDFDatas"
                      :key="item._id"
                    >
                      <div class="section">
                        <div :class="[item.isActive ? 'active' : '', 'collapsible']" @click="item.isActive = !item.isActive">
                          <div class="p-1 px-2">
                            <div class="row align-items-center">
                              <span class="toggleIcon" id="toggleIcon">{{ !item.isActive ? '+' : '-' }}</span>
                              <div class="col-auto">
                                  <img src="@assets/images/projects/project-1.jpg" class="avatar-sm rounded" alt="file-image">
                              </div>
                              <div class="col pl-0" style="white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;">
                                  <a href="javascript:void(0);" class="text-muted font-weight-bold">{{ item.fileName }}</a>
                                  <p class="mb-0">{{ item.size.$numberDecimal | bytes}}</p>
                              </div>
                              <div class="col-auto">
                                <a
                                  @click="onDownloadAttachment(item._id, idx)"
                                  data-toggle="tooltip" 
                                  data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                  data-original-title="Download">
                                    <i class="uil uil-cloud-download font-size-14"></i>
                                </a>
                                <a
                                  @click="onDeleteAttachment(item._id, idx)"
                                  data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                    <i class="uil uil-multiply font-size-14"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <pdf
                        v-for="i in item.numPages"
                        :key="i"
                        :src="item.src"
                        :page="i"
                        style="display: inline-block; width: 100%"
                        v-show="item.isActive"
                      ></pdf>
                    </div>
                  </div>
                </div>  
              </div>
            </div>
          </b-tab>
          <b-tab title="Notes" class="bg-white p-4">
            <div class="card shadow-none">
              <div
                class="d-flex tab_card_content_container align-items-center flex-wrap"
                :class="model.notes && model.notes.length && model.notes.length >= 2 ? 'justify-content-between' : 'justify-content-start'"
              >
                <h5
                  class="card-title pb-2 border-bottom d-flex flex-row justify-content-between align-items-center w-100"
                >
                  Note(s) 
                  <button
                    class="btn2 btn2-primary btn-sm mr-1 mb-3 mb-sm-0"
                    @click="$refs.addNote.show()"
                  >
                    <i class="uil-plus mr-1"></i> Add Note
                  </button>
                </h5>
  
  
                <div class="note" v-if="model.notes && model.notes.length == 0">
                  No application note added.
                </div>
  
                <div
                  class="note note_cards rounded my-2"
                  v-for="(note, idx) in model.notes"
                  :key="note._id || idx"
                  v-html="note.description"
                />
  
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <Dialog
      ref="showTag"
      size="sm"
      centered
      yesText="Add"
      noText="Cancel"
      title="Add Tag"
      :parameters="{ submitted }"
      @onYes="onAddTag"
    />

    <Dialog
      ref="addNote"
      centered
      size="md"
      title="Add Note"
      yesText="Add"
      noText="Cancel"
      :parameters="{ submitted }"
      :component="addNoteComponent"
      @onYes="onAddNote"
    />
  </div>
</template>

<script>
import error from '@utils/error'

import pdf from 'vue-pdf'
import moment from 'moment/moment'
import Dialog from '@components/dialogs'
import SuitableJobs from '../suitableJobs.vue'
import Applications from '../applications.vue'
import NoteComponent from '@components/dialogs/note.vue'

export default {
  components: {
    pdf,
    Dialog,
    SuitableJobs,
    Applications,
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    applicationID() {
      let parameters = this.parameters || {}
      return parameters.applicationID
    },
    prospectID() {
      let parameters = this.parameters || {}
      return parameters.prospectID
    },
    addNoteComponent() {
      return NoteComponent
    },
  },
  data () {
    return {
      model:{
        full_name: '',
        email: '',
        contact_no: '',
        work_experiences:[],
        education_background:[],
        skills:[],
        tags:[],
        attachments:[],
        activities:[],
        applications:[],
        job_id:{
          title:'',
          company_id:{
            name:''
          }
        }
      },
      submitted: false,
      attachmentPDFDatas: [],
      attachmentDatas: []
    }
  },
  filters: {
    date: function (value, format) {
      return moment(value).format(format || 'YYYY-MM-DD')
    },
    custom_date: function (value) {
      return moment(value).format('Mo MMMM YYYY')
    }
  },
  methods: {
    onAddTag(val) {
      let tag = val && val.tag && Object.entries(val.tag).length ? val.tag : val

      delete tag._idx

      tag.prospect_id = this.prospectID
      this.$store.dispatch('prospect/createTag', tag)
      .then(res => {
        if (res && res.data) {
          this.submitted = !this.submitted
          this.$refs.showTag.hide()
          this.model.tags.push(res.data)
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    fetchData() {
      let param = {}
      param.id = this.applicationID
      param.user = this.user ? this.user : {}

      return this.$store.dispatch('application/getApplication', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
          this.attachmentDatas = []
          this.attachmentPDFDatas = []
          if(this.model.avatar_path){
            this.$refs['imageAvatar'].src = this.model.avatar_path
          }

          if(this.model && this.model.applications.length && this.$refs['applications']) {
            this.$refs.applications.fetchData(this.model.applications)
          }

          this.parseDocuments()
        }
      })
    },
    resend() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to resend the consent form?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'RESEND',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.fetchData()
          this.$store.dispatch('application/resendConsent', {
            application:this.model.application || this.model.application_id
          })
          .then(()=>{
            this.$bvToast.toast(`Consent form was re-sent to applicant.`, {
              title: 'Notification',
              variant:'success'
            })
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
    },
    parseDocuments(){
      let attachmentData = this.model.attachments

      if(attachmentData.length > 0){
        for(let index = 0; index < attachmentData.length; index++) {
          const element = attachmentData[index];
          
          if(element.mimetype == 'application/pdf'){
            let pdfsrc = pdf.createLoadingTask(`${process.env.VUE_APP_SERVER_URL}/${element.path}`)
            let numPages = undefined
            pdfsrc.promise.then(pdf => {
              numPages = pdf._pdfInfo.numPages;
              let result = {
                src: pdfsrc,
                numPages,
                currentPage: 0,
                fileName: element.originalname,
                size: element.size,
                _id: element._id,
                isActive: attachmentData.length > 1 ? false : true
              }
              this.attachmentPDFDatas.push(result)
            })
          }
          else {
            let result = {
              fileName: element.originalname,
              size: element.size,
              _id: element._id,
              isActive: false
            }
            this.attachmentDatas.push(result)
          }
        }
      }
    },
    onAddNote(val){
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      this.$store.dispatch('application/createNote', {
        id: this.model.application_id,
        note: model.note
      })
      .then(res => {
        var data = res.data
        this.submitted = !this.submitted
        this.fetchData()
        this.$refs.addNote.hide()
        this.$bvToast.toast(data.toastMessage, {
          title: 'Notification',
          variant:'success'
        })
      })
      .catch((err) => error.errorHandler(err, this.$bvToast))
    },
  },
  mounted () {
    if (this.applicationID) {
      this.fetchData()
    }
  },
  watch: {
    applicationID: function () {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss">
  @media screen and (min-width: 1200px) {
    .col-3s {
      flex: 0 0 28%;
      max-width: 28%;
      padding-left: 12px;
      padding-right: 12px;
    }
    .col-8s {
      flex: 0 0 70%;
      max-width: 70%;
    }

    .application-view-height {
      height: 74vh;
      overflow-y: auto;
      overflow-x: hidden;
      .nav.nav-tabs {
        background: #e8eaee!important;
      }
    }
  }
  .custom-view-tabs {
    background: rgba(255, 255, 255, 0.2);
    border-width: 1px 1px 0px 1px;
    border-style: solid;
    border-color: rgba(3, 0, 19, 0.15);
    box-shadow: 0px 24px 65px rgba(20, 20, 43, 0.16);
    border-radius: 10px 10px 0px 0px;

    .nav-pills {
      background: #fff;

      .active {
        background: rgba(235, 47, 91, 0.1);
        color: #EB2F5B;
      }
    }

    .tab-pane {
      background-color: #e4e4e473;
      padding: 5px 5px 5px;
      height: auto;
    }
  }
</style>
